import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { HotelAwardsBlogPost } from '../../constants/external-routes';
import { CustomCurrencyPipe, IconSvgComponent } from '@roomex/rx-components';

@Component({
  selector: 'rx-applications-award-label',
  templateUrl: './award-label.component.html',
  styleUrls: ['./award-label.component.scss'],
  standalone: true,
  imports: [CommonModule, CustomCurrencyPipe, IconSvgComponent],
})
export class AwardLabelComponent {
  navigateToBlogPost() {
    window.open(HotelAwardsBlogPost, '_blank');
  }
}
